<template>
    <div :class="['direction-card', col]">
        <div class="direction-card__inner">
            <a class="direction-card__cover" :href="url">
                <img :src="image.src" :alt="image.alt" :title="image.title">
                <div class="direction-card__body">
                    <div class="direction-card__text" v-if="text">{{ text }}</div>
                    <div class="direction-card__title">{{ title }}</div>
                    <div class="imgAuthor" v-if="imgAuthor">{{imgAuthor}}</div>
                </div>

            </a>
        </div>
    </div>
</template>

<script>

export default {
    name: 'DirectionCard',
    inheritAttrs: false,
    props: {
        title: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        url: {
            type: String,
            default: '',
        },
        imgAuthor: {
          type: String,
          default: '',
        },
        image: {
            type: String,
            default: '',
        },
        col: {
            type: String,
            default: '',
        }
    },
    setup: (props, ctx) => {
        
        return {

        }
    },
}
</script>

<style lang="scss" scoped>
    .direction-card {
        a {
            color: #fff;
        }
        &__cover {
            display: block;
            line-height: 1px;
            border-radius: var(--br-1);
            overflow: hidden;
            position: relative;
            img {
                object-fit: cover;
                width: 100%;
                height: 100%;
            }
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 31.28%);
                opacity: 0.87;
                pointer-events: none;
                transform: matrix(1, 0, 0, -1, 0, 0);
            }
        }

        &__body {
            position: absolute;
            left: 0;
            bottom: 0;
          width: 100%;
            padding: 32px 30px;
          .imgAuthor {
            color: #aaa;
            font-size: 12px;
            position: absolute;
            left: 10px;
            bottom: 15px;
          }
            @include tablet {
                padding: 22px;
            }
        }
        &__title {
            font-family: var(--font-secondary);
            font-weight: 600;
            font-size: 22px;
            line-height: 28px;
            @include tablet {
                font-size: 16px;
                line-height: 22px;
            }
        }
        &__text {
            margin-bottom: 5px;
            font-size: 14px;
            line-height: 26px;
            @include tablet {
                font-size: 10px;
                line-height: 14px;
            }
        }
    }
</style>
